// `uz.xsib.platform.api.OperationResult` — backend uch holatli natija
// (boolean emas). `PUT /api/selfcare/me/password` shu shaklda javob beradi.
//
// `PARTIAL` bu yerda "baza yangilandi, lekin faol sessiyaga qo'llanmadi"
// degan admin-panel ma'nosini abonent tomonida ham saqlaydi (masalan parol
// bazada yangilandi, lekin FreeRADIUS sinxronizatsiyasi kechikkan bo'lishi
// mumkin) — HTTP 200 bilan keladi, xato emas.

import { z } from 'zod'

export const OPERATION_STATUSES = ['OK', 'PARTIAL', 'FAILED'] as const
export type OperationStatus = (typeof OPERATION_STATUSES)[number]

export const operationResultSchema = z.object({
  status: z.enum(OPERATION_STATUSES),
  message: z.string().nullish(),
  detail: z.string().nullish(),
})

export type OperationResult = z.infer<typeof operationResultSchema>
